export const addProduct = (code, name, categoryId, rateId) => {
  return `mutation {
        addProduct(code:"${code}", name:"${name}", categoryId:${categoryId}, rateId:${rateId}) {
            id
            name
        }
    }`
}

export const updateProduct = (id, name, code, categoryId, rateId) => {
  return `mutation {
        updateProduct(id:${id}, name:"${name}", code:"${code}",categoryId:${categoryId}, rateId:${rateId}) {
            id
            code
            name
        }
    }`
}

export const deleteProduct = (id) => {
  return `mutation {
        deleteProduct(id:${id}) {
            id
            code
            name
        }
    }`
}
